import { NotificationResource } from '../../types/NotificationResource';
import { NotificationActions, NotificationActionsType } from './NotificationActions';

export interface INotificationsState {
  loading: boolean;
  items: NotificationResource[];
  filter: string;
  filteredItems: Array<NotificationResource>;
  unreadFilteredItems: Array<NotificationResource>;
  isExportNotification: boolean;
}

const initialState: INotificationsState = {
  loading: false,
  items: [],
  filter: '',
  filteredItems: [],
  unreadFilteredItems: [],
  isExportNotification: false,
};

export const notificationsReducer = (
  state = initialState,
  action: NotificationActions,
): INotificationsState => {
  switch (action.type) {
    case NotificationActionsType.LOAD_NOTIFICATIONS: {
      return { ...state, loading: true };
    }

    case NotificationActionsType.LOAD_NOTIFICATIONS_SUCCESS: {
      return {
        ...state,
        loading: false,
        items: action.payload,
      };
    }

    case NotificationActionsType.LOAD_NOTIFICATIONS_FAIL: {
      return { ...state, loading: false };
    }

    case NotificationActionsType.UPDATE_NOTIFICATIONS: {
      return {
        ...state,
        items: action.payload.items,
        filteredItems: action.payload.filteredItems,
      };
    }

    case NotificationActionsType.UPDATE_NOTIFICATIONS_FILTER: {
      return {
        ...state,
        filter: action.payload.filter,
        filteredItems: action.payload.filteredNotifs,
      };
    }

    case NotificationActionsType.UPDATE_FILTERED_NOTIFICATIONS_FILTER: {
      return {
        ...state,
        filteredItems: action.payload.filteredNotificatiions,
        unreadFilteredItems: action.payload.unreadFilteredNotifications,
      };
    }

    case NotificationActionsType.BULK_PRINT_SHOULD_LOAD: {
      return {
        ...state,
        isExportNotification: action.payload || false,
      };
    }

    default: {
      return state;
    }
  }
};
